import React from "react";
import { t } from "i18next";

export default function CandidateReadinessBadges({ candidate }) {
  if (!candidate) return null;
  const kyc = candidate.isKycVerified ?? candidate.IsKycVerified;
  const freshness = candidate.profileFreshness || candidate.ProfileFreshness;
  const due = candidate.profileRefreshDue ?? candidate.ProfileRefreshDue;
  const percent = candidate.completionPercent ?? candidate.CompletionPercent;
  const age = candidate.profileAgeDays ?? candidate.ProfileAgeDays;
  const missing = candidate.missingFields || candidate.MissingFields || [];

  return (
    <div className="wlj-status-row">
      {kyc ? (
        <span className="wlj-status-chip wlj-status-chip--ok">{t("Recruiter.KycDone")}</span>
      ) : (
        <span className="wlj-status-chip wlj-status-chip--muted">{t("Recruiter.KycPending")}</span>
      )}
      {percent != null && (
        <span
          className={`wlj-status-chip ${percent >= 80 ? "wlj-status-chip--ok" : "wlj-status-chip--warn"}`}
          title={missing.length ? `${t("Recruiter.Missing")}: ${missing.join(", ")}` : ""}
        >
          {t("Recruiter.Profile")} {percent}%
        </span>
      )}
      {freshness === "Overdue" && (
        <span className="wlj-status-chip wlj-status-chip--alert">
          {t("Recruiter.ProfileOverdue")}
          {age ? ` (${age}d)` : ""}
        </span>
      )}
      {freshness === "DueSoon" && due && (
        <span className="wlj-status-chip wlj-status-chip--warn">
          {t("Recruiter.UpdateDueSoon")}
          {age ? ` (${age}d)` : ""}
        </span>
      )}
    </div>
  );
}
